import axios from "axios";
import enviroment from "../config/env";
import paraguay from "../config/paraguay";
import { createAuthAxiosInstance } from "./authAxiosFactory";
import { getActiveEnvironment } from "./environmentService";
import { anotarHoraDelServidor } from "./relojDelServidor";

const getEnvironment = async () => {
  try {
    const activeEnv = await getActiveEnvironment();
    return { ...activeEnv, bcBaseUrl: enviroment.bcBaseUrl };
  } catch (error) {
    console.warn("Falling back to default environment:", error);
    return null;
  }
};

/**
 * Implementación del servicio de actualización de token para la aplicación principal (BC).
 * @type {import("./authAxiosFactory").TokenRefreshService}
 */
const bcTokenRefreshService = async () => {
  const env = await getEnvironment();

  // Usamos una instancia de axios sin interceptores para prevenir bucles de actualización
  const tempAxios = axios.create();

  const response = await tempAxios.post(`${env.apiUrl}/auth/token`, {
    pais: env.country?.trim(),
  });

  const { access_token, expires_in } = response.data.token;

  // Mapeamos la respuesta al contrato requerido por la fábrica
  return { access_token, expires_in };
};

// Instancia de Axios para la aplicación principal (BC)
export const bcApi = createAuthAxiosInstance({
  tokenKey: "bc_token",
  expiryKey: "bc_token_expiry",
  tokenRefreshService: bcTokenRefreshService,
  baseURL: enviroment.apiUrl,
});

// La hora de Business Central viaja en la cabecera Date de cada respuesta, y BC
// la expone al navegador (medido el 14/09/2026). Se anota la última para
// comprobar el reloj del equipo sin ninguna llamada de más (AvisoDeHuso.js).
bcApi.interceptors?.response?.use((respuesta) => {
  anotarHoraDelServidor(respuesta?.headers);
  return respuesta;
});

/**
 * Implementación del servicio para SICFE (Facturacion electronica Paraguay).
 * @type {import("./authAxiosFactory").TokenRefreshService}
 */
const sicfeRefreshService = async () => {
  // Usamos una instancia de axios sin interceptores para prevenir bucles de actualización
  const tempAxios = axios.create();

  const response = await tempAxios.post(`${enviroment.apiUrl}/auth/sicfe`, {
    pais: "PY",
  });

  const { access_token, expires_in } = response.data.token;

  // Mapeamos la respuesta al contrato requerido por la fábrica
  return { access_token, expires_in };
};

// Instancia de Axios para Sicfe
export const sicfeApi = createAuthAxiosInstance({
  tokenKey: "sicfe_token",
  expiryKey: "sicfe_token_expiry",
  tokenRefreshService: sicfeRefreshService,
  baseURL: `${paraguay.sicfeBaseUrl}/${paraguay.env}/v1/${paraguay.tenant}`,
});
